export const calculateIfRightLabelShouldChangePosition = ({
  isControlledComponent,
  value,
  localState,
  max,
  min,
  step
}: {
  isControlledComponent: boolean;
  value?: number[];
  localState?: number[];
  max: number;
  min: number;
  step: number;
}) => {
  const isMultiSlider = isControlledComponent
    ? value && value?.length > 1
    : localState && localState?.length > 1;
  if (!isMultiSlider) return false;
  const valueDifference =
    isMultiSlider && isControlledComponent
      ? value && value[1] - value[0]
      : localState && localState[1] - localState[0];
  const maxDiff = max - min;
  const differencePercentage =
    valueDifference && (valueDifference / maxDiff) * 100;
  const numberOfSteps = max / step;
  const shouldChangeLabelPosition =
    numberOfSteps > 25 && differencePercentage && differencePercentage < 12;
  return shouldChangeLabelPosition;
};
